<div class="py-[30px]">
  <div>
    <div class="flex flex-row items-center justify-between">
      <div>
        <div class="v4-layout-form mr-[20px]">
          <div class="v4-layout-form-title">
            {{ "booking-site_detail-basis_set_base_price" | translate }}
            <!-- Set base price -->
            @if (showBasePriceIcon) {
              <span nz-icon nzType="exclamation-circle" nzTheme="fill" class="text-[#ff7a3c] text-[20px]"></span>
            }
          </div>
          <div class="v4-layout-form-desc">
            {{ "booking-site_detail-basis_set_base_price_desc" | translate }}
            <!-- Before you start using, you need to set a base price. -->
          </div>
        </div>
      </div>
      <div>
        <button nz-button nzSize="large" (click)="setPriceModal = true">
          {{ "property-property_detail-advanced_html_设置" | translate }}
          <!-- Set -->
        </button>
      </div>
    </div>
  </div>

  @if (type === "hostex") {
    <div class="mt-12">
      <div class="flex flex-row items-center justify-between">
        <div>
          <div class="v4-layout-form mr-[20px]">
            <div class="v4-layout-form-title">
              {{ "booking-site_detail-basis_complete_info" | translate }}
              <!-- Complete the basic information -->
              @if (inProgress) {
                <span nz-icon nzType="exclamation-circle" nzTheme="fill" class="text-[#ff7a3c] text-[20px]"></span>
              }
            </div>
            <div class="v4-layout-form-desc">
              {{ "booking-site_detail-basis_complete_info_desc" | translate }}
              <!-- Before you start using, you need to fill in the property description, set prices and rules, and upload
              photos. -->
            </div>
          </div>
        </div>
        <div>
          <a [href]="setFeesUrl" target="_blank">
            <button nz-button nzSize="large">
              {{ "property-property_detail-advanced_html_设置" | translate }}
              <!-- Set -->
            </button>
          </a>
        </div>
      </div>
    </div>
  } @else {
    <div class="mt-12">
      <div class="flex flex-row items-center justify-between">
        <div>
          <div class="v4-layout-form mr-[20px]">
            <div class="v4-layout-form-title">
              {{ "booking-site_detail-basis_set_fees" | translate }}
              <!-- Set fees & rules -->
            </div>
            <div class="v4-layout-form-desc">
              {{ "booking-site_detail-basis_set_fees_desc" | translate }}
              <!-- Set the cleaning fee, availability window, and house rules. -->
            </div>
          </div>
        </div>
        <div>
          <a [href]="setFeesUrl" target="_blank">
            <button nz-button nzSize="large">
              {{ "property-property_detail-advanced_html_设置" | translate }}
              <!-- Set -->
            </button>
          </a>
        </div>
      </div>
    </div>
  }

  <div class="mt-12">
    <div class="flex flex-row items-center justify-between">
      <div>
        <div class="v4-layout-form mr-[20px]">
          <div class="v4-layout-form-title">
            {{ "booking-site_detail-basis_set_booking_res" | translate }}
            <!-- Set booking restrictions & policies -->
          </div>
          <div class="v4-layout-form-desc">
            {{ "booking-site_detail-basis_set_booking_res_desc" | translate }}
            <!-- Set the minimum stay, cancellation policy, instant booking, and more. -->
          </div>
        </div>
      </div>
      <div>
        <a [href]="setRatePlanUrl" target="_blank">
          <button nz-button nzSize="large">
            {{ "property-property_detail-advanced_html_设置" | translate }}
            <!-- Set -->
          </button>
        </a>
      </div>
    </div>
  </div>

  <div class="mt-12">
    <div class="flex flex-row items-center justify-between">
      <div>
        <div class="v4-layout-form mr-[20px]">
          <div class="v4-layout-form-title">
            {{ "booking-site_detail-basis_set_daily_price" | translate }}
            <!-- Set daily price -->
          </div>
          <div class="v4-layout-form-desc">
            {{ "booking-site_detail-basis_set_daily_price_desc" | translate }}
            <!-- Go to the "Price" section to set the daily prices for the booking site. -->
          </div>
        </div>
      </div>
      <div>
        <a routerLink="/app/price">
          <button nz-button nzSize="large">
            {{ "property-property_detail-advanced_html_设置" | translate }}
            <!-- Set -->
          </button>
        </a>
      </div>
    </div>
  </div>
</div>

<nz-modal (nzOnCancel)="setPriceModal = false" [(nzVisible)]="setPriceModal" nzWidth="430">
  <div *nzModalTitle>Pricing</div>
  <div *nzModalContent>
    <div class="v4-layout-form v4-layout-form-vertical" [formGroup]="form">
      <!--      <div class="v4-layout-field">-->
      <!--        <div class="v4-layout-field-label">Currency</div>-->
      <!--        <div class="v4-layout-field-control">-->
      <!--          <div class="v4-layout-field-row">-->
      <!--            <nz-select nzSize="large"></nz-select>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <div class="v4-layout-field">
        <div class="v4-layout-field-label">Base price</div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <input type="number" nz-input nzSize="large" placeholder="Input a number" formControlName="base_price" />
          </div>
        </div>
      </div>

      <div class="v4-layout-field">
        <div class="v4-layout-field-label">Weekend price</div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <input type="number" nz-input nzSize="large" placeholder="Input a number" formControlName="weekend_price" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *nzModalFooter>
    <button nz-button nzType="primary" (click)="onSetPrices()">Save</button>
  </div>
</nz-modal>
